import { environment } from '../../environments/environment';

export class DevelopUtil {
  public static getHost() {
    return environment.serviceUrl;
  }

  public static url(url: string) {
    return this.getHost() + url;
  }
  
  // file size in bytes
  // * deprecated
  public static fileSize = environment.attachments.fileSize;
  public static fileType = environment.attachments.extensions;
}



// WEBPACK FOOTER //
// ./src/app/utils/develop.utils.ts